import { useEffect } from 'react';

/** Matches the <title> in index.html — restored when a page unmounts. */
const DEFAULT_TITLE = 'Showliner: booking and show-night software for independent venues and artists';

/**
 * Sets the document title for a page. Pass nothing (or undefined, e.g. while
 * an entity is still loading) to keep the site-wide default. The profile
 * Share button reads document.title, so entity pages should pass the
 * entity's name once it's available.
 */
export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} · Showliner` : DEFAULT_TITLE;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
}

/** JSX form of usePageTitle, for expression-bodied page components. */
export const PageTitle = ({ title }: { title?: string }) => {
  usePageTitle(title);
  return null;
};
